/**
 * Sentry browser bootstrap (STARSEED-CAPMARKETS-026).
 *
 * Env-gated: when REACT_APP_SENTRY_DSN is absent from the build (local dev,
 * CI builds without the var) this is a silent no-op — the bundle never
 * requires a DSN. CRA inlines REACT_APP_* at build time (RTC-R-01
 * category 3, build-time constants; rows E60-E62 in
 * docs/architecture/capital-markets-env-rtc-mapping.md):
 *
 * - REACT_APP_SENTRY_DSN         — enables Sentry when present.
 * - REACT_APP_RELEASE            — git SHA baked at build by the deploy
 *   workflow (starseed-capmarkets-024-deploy-workflows.md), mirroring the
 *   API's APP_RELEASE contract.
 * - REACT_APP_SENTRY_ENVIRONMENT — `stage` / `prod` tag (defaults to
 *   Sentry's own "production" default when unset).
 *
 * PII posture (the app handles KYC / investor data): sendDefaultPii stays
 * false (SDK default, pinned explicitly) and beforeSend strips request
 * bodies/cookies/headers from every event so form contents (KYC fields,
 * passwords) can never ride along.
 *
 * Project topology: capital-markets uses its OWN Sentry project (own DSN,
 * own quota) — DRIFT-052 quota isolation; see the API-side twin in
 * apps/capital-markets-api/core/observability.py.
 */
import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return false;

  Sentry.init({
    dsn,
    release: process.env.REACT_APP_RELEASE || undefined,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || undefined,
    // KYC/investor data — never attach PII or request payloads.
    sendDefaultPii: false,
    beforeSend(event) {
      if (event.request) {
        delete event.request.data;
        delete event.request.cookies;
        delete event.request.headers;
      }
      return event;
    },
  });
  return true;
}
